export default "__VITE_ASSET__7b351343__"